import { gql } from '@apollo/client';

import { PayloadProps as PortfolioPayloadProps } from '@graphql/query/portfolio';

export interface ResponseProps {
  downloadPortfolioData: {
    downloadUrl?: string;
  };
}

export type PayloadProps = PortfolioPayloadProps & {
  simulationId: string;
};

const DOWNLOAD_PORTFOLIO_DATA = gql`
  query downloadPortfolioData(
    $simulationId: ID!
    $startYear: String!
    $endYear: String
    $energyType: [String!]
    $periodType: QuotePeriod
    $priceType: [QuotePrice!]
    $excludedContracts: [ID!]
    $tenantId: [ID!]
    $internalAccounts: [ID!]
    $usageFactorByAngra: Boolean
    $usageFactor: Boolean
    $giro: String
    $hasGiro: Boolean
    $contractFlags: [String!]
    $market: [Market!]
    $accountingPortfolio: ContractPortfolio
    $closeDateLte: ISO8601Date
    $closeDateGte: ISO8601Date
    $modulation: [PortfolioModulation!]
    $includeSuspendedContracts: Boolean
  ) {
    downloadPortfolioData(
      simulationId: $simulationId
      startYear: $startYear
      endYear: $endYear
      energyType: $energyType
      periodType: $periodType
      priceType: $priceType
      excludedContracts: $excludedContracts
      tenantId: $tenantId
      internalAccounts: $internalAccounts
      usageFactorByAngra: $usageFactorByAngra
      usageFactor: $usageFactor
      giro: $giro
      hasGiro: $hasGiro
      contractFlags: $contractFlags
      market: $market
      accountingPortfolio: $accountingPortfolio
      closeDateLte: $closeDateLte
      closeDateGte: $closeDateGte
      modulation: $modulation
      includeSuspendedContracts: $includeSuspendedContracts
    ) {
      downloadUrl
    }
  }
`;

export default DOWNLOAD_PORTFOLIO_DATA;
